export default __webpack_public_path__ + "static/media/轮播首图3.eac83416.jpg";